import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAttendanceDepartments } from '../../../../../reduxToolkit/EmployeePayRoll/EmployeePayRollApi';
import {ATTENDANCE_SUBVIEW_MODEL} from '../Model/Model';
import {errorMsg} from '../../../../../Apis/functions';
import {GetAllDepartments} from '../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalitySchedule = (
    {
        registerAction
    }
) => {
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState([]);
    const [dataUpdate, setDataUpdate] = useState();
    const [modified, setModified] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showUpdatedModal, setShowUpdatedModal] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    /**
     * Triggers the initial loading of departments and additional data
     * required for the view when the component is mounted.
     */
    useEffect(() => {
        dispatch(GetAllDepartments());
        getData();
    }, []);

    /**
     * Watches the `modified` state to detect data changes.
     * When it becomes true, it reloads the updated data
     * and resets the state to prevent repeated executions.
     */
    useEffect(() => {
        if(modified){
            getData();
            setModified(false);
        }
    }, [modified]);

    /**
     * Fetches attendance department data from the global state
     * and updates the search results when the response is successful.
     * If an error occurs, the corresponding message is displayed.
     */
    const getData = () => {
        dispatch(GetAttendanceDepartments()).then(({payload: {data: { data, success, code }}}) => {
            if (success) {
                setSearchResults(geOrderData(data));
            }else errorMsg(code);
        });
    }

    /**
     * Sorts the data list by placing items without an assigned department
     * (`departmentId === null`) first, followed by the remaining records.
     */
    const geOrderData = (data) => {
        return data.reduce((acc, picker) => {
            picker.departmentId === null
                ? acc.unshift(picker)
                : acc.push(picker);
            return acc;
        }, []);
    };

    /**
     * This function sets the data to be updated and displays the modal to confirm the update
     */
    const handleUpdate = (data) => {
        setDataUpdate(data);
        setShowUpdatedModal(true);
    };

    /**
     * This function sets the state to show the modal for confirming schedule deletion
     */
    const handleRemoveSchedule = (item) => {
        setSelectedIds([item.id]);
        setShowDeleteModal(true);
    };

    /**
     * Opens the modal to create a new record.
     */
    const handleCreate = () => {
        setShowCreateModal(true);
    };

    /**
     * Registers the `handleCreate` action for the department policies subview
     * when the component is mounted, allowing the view to trigger
     * the create modal.
     */
    useEffect(() => {
        registerAction(
            ATTENDANCE_SUBVIEW_MODEL.MANAGE.DEPARTMENT_POLICIES,
            { handleCreate }
        );
    }, []);

    return {
        searchResults,
        handleCreate,
        handleUpdate,
        handleRemoveSchedule,
        showDeleteModal,
        setShowDeleteModal,
        showCreateModal,
        setShowCreateModal,
        showUpdatedModal,
        setShowUpdatedModal,
        dataUpdate,
        selectedIds,
        DEV,
        permission,
        setModified,
    };
};
export default FunctionalitySchedule;
